"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROIStep = void 0;
var classnames_1 = __importDefault(require("classnames"));
var PromptLayout_1 = require("Common/Prompt/PromptLayout");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var UseHistoryTypes_1 = require("DataStores/User/UseHistory/UseHistoryTypes");
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var react_1 = __importDefault(require("react"));
var ROIStepsContext_1 = require("./ROIStepsContext");
var stopEventPropagation = function (event) {
    event.nativeEvent.stopImmediatePropagation();
    event.stopPropagation();
};
var roiStepToTooltipClassName = function (step) {
    var _a;
    return "roi-calculator__step--" +
        (_a = {},
            _a[UseHistoryTypes_1.ROIStepId.AddEditVariables] = "add-edit-variables",
            _a[UseHistoryTypes_1.ROIStepId.EditSlider] = "edit-slider",
            _a[UseHistoryTypes_1.ROIStepId.Formula] = "formula",
            _a[UseHistoryTypes_1.ROIStepId.FormulaEditor] = "formula-editor",
            _a[UseHistoryTypes_1.ROIStepId.ShowVariables] = "show-variables",
            _a)[step];
};
var ROIStep = (function (_super) {
    __extends(ROIStep, _super);
    function ROIStep() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleGotIt = function () {
            _this.context.orchestrator.completeStep(_this.props.id);
        };
        return _this;
    }
    ROIStep.prototype.render = function () {
        var _a = this.props, children = _a.children, id = _a.id;
        return (react_1.default.createElement(kaleidoscope_1.Tooltip, { size: kaleidoscope_1.TooltipSize.Large, className: (0, classnames_1.default)("roi-calculator__step", roiStepToTooltipClassName(id)), content: react_1.default.createElement("div", { onClick: stopEventPropagation, onMouseDown: stopEventPropagation },
                react_1.default.createElement(PromptLayout_1.PromptLayout, { heading: getHeading(id), content: getBody(id), button: react_1.default.createElement(kaleidoscope_1.Button, { type: kaleidoscope_1.ButtonType.Secondary, theme: kaleidoscope_1.ButtonTheme.Dark, size: kaleidoscope_1.ButtonSize.XSmall, onClick: this.handleGotIt }, "Got it") })), show: this.show, position: this.position, autoStack: true }, children));
    };
    Object.defineProperty(ROIStep.prototype, "show", {
        get: function () {
            return this.context.orchestrator.shouldShowStep(this.props.id);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ROIStep.prototype, "position", {
        get: function () {
            if (this.props.id === UseHistoryTypes_1.ROIStepId.FormulaEditor) {
                return kaleidoscope_1.TooltipPosition.Left;
            }
            return undefined;
        },
        enumerable: false,
        configurable: true
    });
    ROIStep.contextType = ROIStepsContext_1.ROIStepsContext;
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], ROIStep.prototype, "show", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], ROIStep.prototype, "handleGotIt", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], ROIStep.prototype, "position", null);
    ROIStep = __decorate([
        mobx_react_1.observer
    ], ROIStep);
    return ROIStep;
}(react_1.default.Component));
exports.ROIStep = ROIStep;
var getBody = function (id) {
    var _a;
    return ((_a = {},
        _a[UseHistoryTypes_1.ROIStepId.FormulaEditor] = (react_1.default.createElement(react_1.default.Fragment, null,
            "The formula takes in variables from your buyer to calculate a result.",
            " ",
            react_1.default.createElement(kaleidoscope_1.Link, { href: "https://help.qwilr.com/article/706-writing-a-formula-for-the-roi-calculator", theme: kaleidoscope_2.LinkTheme.Dark, target: "_blank" }, "Watch a video on how to write formulas"))),
        _a[UseHistoryTypes_1.ROIStepId.Formula] = "The ROI calculator displays an amount of savings based on a formula. To edit the formula, click this button.",
        _a[UseHistoryTypes_1.ROIStepId.ShowVariables] = 'To view and edit variables for your ROI calculation, click "Show calculator"',
        _a[UseHistoryTypes_1.ROIStepId.AddEditVariables] = 'All of the variables here can be tailored to your business. To add more, click the "Add variable" button',
        _a[UseHistoryTypes_1.ROIStepId.EditSlider] = "The slider is for the primary variable in your formula. Your buyer can interact with the slider and variables to change the ROI. Edit the slider here",
        _a)[id]);
};
var getHeading = function (id) {
    var _a;
    return ((_a = {},
        _a[UseHistoryTypes_1.ROIStepId.Formula] = "ROI formula",
        _a[UseHistoryTypes_1.ROIStepId.FormulaEditor] = "Formula editor",
        _a[UseHistoryTypes_1.ROIStepId.ShowVariables] = "Show variables",
        _a[UseHistoryTypes_1.ROIStepId.AddEditVariables] = "Add and edit variables",
        _a[UseHistoryTypes_1.ROIStepId.EditSlider] = "Edit the slider",
        _a)[id]);
};
